/* eslint-disable react/jsx-pascal-case */
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Ddmmmyyyy_date } from "../../../../utility";

// Function to extract company name from description
const extractCompanyName = (description) => {
  const jsonPart = description.match(/{.*}/);
  if (jsonPart) {
    try {
      const data = JSON.parse(jsonPart[0]);
      return data.companyName || "";
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return "";
    }
  }
  return "";
};

// Function to modify event description
const modifyEventDescription = (description) => {
  const companyName = extractCompanyName(description);
  const regex = /{.*?}/;
  return description.replace(regex, companyName);
};

const TimeLineDetails = ({ dataObject, close }) => {
  console.log(dataObject);
  let data = dataObject.details;
  const modifiedDescription = modifyEventDescription(data.eventDescription);

  return (
    <>
      <div>
        <div
          className="d-grid justify-content-end mx-sm-4"
          style={{ marginTop: -20 }}
        >
          <button className="btn btn-outline-danger p-1" onClick={close}>
            <CloseIcon />
          </button>
        </div>
        <p>
          <strong>Event:</strong>
          &nbsp;{data.eventName}
        </p>
        <p className="d-flex">
          <strong>Description:&nbsp;</strong>
          <div
            dangerouslySetInnerHTML={{
              __html: modifiedDescription,
            }}
          />
        </p>
        {data.notes && (
          <p>
            <strong>Notes:</strong>
            &nbsp;{data.notes}
          </p>
        )}
        <p>
          {" "}
          <strong>Posted On: </strong>{" "}
          {<Ddmmmyyyy_date dateValue={data.createdTime} />}
        </p>
      </div>
    </>
  );
};

export default TimeLineDetails;
